import { call, put } from "redux-saga/effects";
import { postAsync } from "../commonAsync";
import {toggleAlert, toggleAlertActionCreator, toggleLoading} from '../../slices'

export function* createRoleSaga(action) {
  try {
    yield put(toggleLoading(true))
    const response = yield call(postAsync, "roles", action.payload.role)
    if (yield response.ok) {
      yield put(toggleAlert(toggleAlertActionCreator('success', 'Role created successfully')))
      yield action.payload.push('/roles')
    }
    else {
      const errorCode = yield response.status;
      const { Error } = yield response.json();
      const errorMessages = yield Error?.map(error => error?.message).join(",")
      yield put(toggleAlert(toggleAlertActionCreator('error', `${errorCode}: ${errorMessages}`)))
    }
    yield put(toggleLoading(false))
  }
  catch (error) {
    yield put(toggleAlert(toggleAlertActionCreator('error', error?.toString())))
  }
}
